(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["battery-capacity-filter"] && !Shopify.designMode) return;
  try {
    (() => {
    const selectors = document.querySelectorAll('[data-battery-capacity-select]');

    selectors.forEach((select) => {
      select.addEventListener('change', () => {
        const url = new URL(window.location.href);
        const filterParam = select.dataset.filterParam;

        if (!filterParam) return;

        url.searchParams.delete(filterParam);

        if (select.value) {
          url.searchParams.set(filterParam, select.value);
        }

        url.searchParams.delete('page');
        window.location.assign(url.toString());
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tire-size-filter"] && !Shopify.designMode) return;
  try {
    (() => {
    document.querySelectorAll('[data-tire-size-filter]').forEach((container) => {
      const axes = Array.from(container.querySelectorAll('[data-tire-measure-axis]'));
      const order = ['ancho', 'perfil', 'aro'];

      const syncSelectState = (select) => {
        select.classList.toggle('has-value', Boolean(select.value));
      };

      axes.forEach((select) => {
        syncSelectState(select);

        select.addEventListener('change', () => {
          syncSelectState(select);
          const url = new URL(window.location.href);
          const changedIndex = order.indexOf(select.dataset.tireMeasureAxis);

          axes.forEach((axis, index) => {
            if (index >= changedIndex) url.searchParams.delete(axis.dataset.filterParam);
          });

          if (select.value) url.searchParams.set(select.dataset.filterParam, select.value);
          url.searchParams.delete('page');
          window.location.assign(url.toString());
        });
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
